import { useSearchParams } from "react-router-dom";
import { json } from "stream/consumers";

const CONST_LABELS_LNG = {
  "lbl.test": { en: "test-en", ar: "" },
  "lbl.test1": { en: "test1-en", ar: "test1-ar" },
};

const resourceKey = {
  antifraud: "b4be15f3-4fbb-4ee0-9b66-2a1cd8bc8cc0",
  subRequest: "8ad9ae14-6da3-4d2a-a196-9eba372ef914",
  subConfirm: "8b984b93-7c74-46e5-a37e-a2c195aa7221",
};

const CONST_CONF = new Map<string, string>([
  ["PRJ_HOME_URL", "/toonzqat"],
  ["IS_TEST_ENV", "0"],
  ["IS_PROD", "0"],
  ["PRINT_LOG", "0"],
  ["AFF_SRC", "MPLP"],
  ["URL_SUB_REQ", "/dev/digital/digital/sub/subReq/%s/%s"],
  ["URL_SUB_CONFIRM_REQ", "/dev/digital/digital/sub/subConfirm/%s/%s"],
  ["JSON_SUB_REQ", '{"msisdn": "%s", "reqId": "%s","websrc":"%s"}'],
  ["JSON_SUB_CONFIRM_REQ", '{"subReqId":"%s","otp":"%s", "msisdn": "%s"}'],

  //Configurations start
  ["IS_REDIRECT_SUCCESS", "1"],
  ["PRJ_URL_HOME_SUCCESS", "/toonz-qat/success"],
  ["URL_REDIRECT_ALREADY_SUB", "https://mytoonz.club/ott/account/signin.php"],
  ["URL_REDIRECT_SUCCESS", "https://mytoonz.club/ott/account/signin.php"],
  ["UNSUB_CMD", "unsub toonz"],
  ["UNSUB_CMD", ""],
  ["SITE_DESC", "toonz app"],

  ["gTagId", "GTM-NP5XBTF"],

  ["GADV-AW", "AW-10998260315/Q9kgCKrc2IkYENvEsPwo"],
]);

const regex = /^((\+|00)?973)(3\d{2}|663|669)\d{5}$/


const CONST_LABELS = new Map<string, string>([
  ["LBL_ENTERED_WRONG_NUMBER", "Enter Valid Mobile number"],
  ["LBL_ERR_INVALID_MSISDN", "Please enter valid Batelco number."],
  ["LBL_ENTERED_WRONG_COUNTRYCODE", "Enter Mobile Number with 974 Code"],
  ["COUNTRY_CODE", "973"],
  ["PHONE_LENGTH", "11"],
  ["PRODUCT_ID_1", "11"],
  ["PRODUCT_ID_2", "1000"],
  ["PIN_LENGTH", "4"],
  ["LBL_TITLE", "Toonz APP"],
  ["LBL_ENTER_MOBILE_TO_GET_PIN", "Enter Your Mobile Number"],
  ["LBL_ENTER_PIN_RECEIVED", "Enter PIN received."],
  ["LBL_ERR_PIN_EMPTY", "Enter valid PIN received."],
  ["LBL_ERR_PIN_WRONG", "Wrong PIN entered."],
  ["LBL_BTN_SUB", "SUBSCRIBE"],
  ["LBL_BTN_WAIT", "Processing..."],
  ["LBL_BTN_CONFIRM", "Confirm"],
  ["LBL_CP_CONTACT_EMIAL", "info@toonzmediagroup.com"],
  ["LBL_TITLE_MAIN_MOBILE", "Enter Mobile Number"],
  ["LBL_TITLE_MAIN_PIN", "Enter PIN received"],
  ["LBL_GTM_PREFIX_OTP", "OTP-REQ-"],
  ["LBL_GTM_PREFIX_OTPCONFIRM", "OTP-CONFIRM-"],
]);

const CONST_TERMS = new Map<string, string>([

  [
    "LBL_SUCCESSFOOTER",
    "You will recieve your credentials to access the Toonz app via SMS shortly." +
    "<br>Daily subscription would be renewed @BD 0.2 per day, automatically until you unsubscribe." +
    "<br><a href=\"https://mytoonz.club/ott/account/signin.php\">Click here</a> to access the Toonz app" +
    " <br></br>For support, please contact <a href='mailto:info@toonzmediagroup.com'>info@toonzmediagroup.com</a>",
  ],
]);

//@ts-ignore
function regConversion() {
  console.log(
    "Env: " +
      getEnv() +
      ", GTM--->regConversion called for,Conversion recorded "
  );
  var i = { send_to: CONST_CONF.get("GADV-AW"), value: 7.5, currency: "AED" };
  //@ts-ignore
  //gtag_event('conversion',i,CONST_CONF.get("GADV-AW"));
  //gtag_event("conversion",i,CONST_CONF.get("GADV-AW")  );
  //@ts-ignore
  gtag("event", "conversion", {
    send_to: "AW-10998260315/Q9kgCKrc2IkYENvEsPwo",
  });
}

//@ts-ignore
function regGtagOtpValidate(eventString, jsonResponse, campaignId) {
  var lp = window.location.href;
  var campaignName = campaignId; //TODO:: Get this value from url parameter like c=Campaign-1

  if (campaignName === null || campaignName === "")
    jsonResponse["campaignId"] = "N/A";
  else jsonResponse["campaignId"] = campaignName;

  jsonResponse["landingPage"] = lp;

  // {"resCode":0,"resDesc":null,"jsString":null,"resId":null,"reqUniqueId":null,"clientReqId":"0d6a4a8d-9cb6-4782-8edd-f087f664bf1c","otp":null,"cgURL":null,"iErrCode":0,"iErrDesc":null,"iTimeTaken":null}

  //https://digital.mktgmob.me/mkt/toonz/qat/digiw1?c=Camapign-1
  console.log(
    "Env: " +
      getEnv() +
      ", GTM--->regGtagOtpValidate called for " +
      eventString +
      ", json: " +
      JSON.stringify(jsonResponse)
  );
  //@ts-ignore
  gtag_event(
    CONST_LABELS.get("LBL_GTM_PREFIX_OTPCONFIRM") + eventString,
    jsonResponse,
    // CONST_CONF.get("gTagUA")
      process.env.REACT_APP_GTAGUA
  );
  //gtag_event(CONST_LABELS.get("LBL_GTM_PREFIX_OTPCONFIRM")+"-GTM-"+e,i,CONST_CONF.get("gTagId"));
  //@ts-ignore
  gtagGA4(
    "event",
    CONST_LABELS.get("LBL_GTM_PREFIX_OTPCONFIRM") + eventString,
    JSON.stringify(jsonResponse)
  );

  //@ts-ignore
  gtagGTM(
    "event",
    CONST_LABELS.get("LBL_GTM_PREFIX_OTPCONFIRM") + eventString,
    JSON.stringify(jsonResponse)
  );
}
//@ts-ignore (2nd method)
function regGtagOtpWithJson(eventString, jsonResponse, campaignId) {
  var lp = window.location.href;
  var campaignName = campaignId;

  if (campaignName === null || campaignName === "")
    jsonResponse["campaignId"] = "N/A";
  else jsonResponse["campaignId"] = campaignName;

  jsonResponse["landingPage"] = lp;

  console.log(
    "Env: " +
      getEnv() +
      ", GTM--->regGtagOtpWithJson called for " +
      eventString +
      ", json: " +
      JSON.stringify(jsonResponse)
  );
  //@ts-ignore
  gtag_event(
    CONST_LABELS.get("LBL_GTM_PREFIX_OTP") + eventString,
    jsonResponse,
      // CONST_CONF.get("gTagUA")
      process.env.REACT_APP_GTAGUA
  );
  //gtag_event(CONST_LABELS.get("LBL_GTM_PREFIX_OTP")+"-GTM-"+e,i,CONST_CONF.get("gTagId"));
  //@ts-ignore
  gtagGA4(
    "event",
    CONST_LABELS.get("LBL_GTM_PREFIX_OTP") + eventString,
    JSON.stringify(jsonResponse)
  );

  //@ts-ignore
  gtagGTM(
    "event",
    CONST_LABELS.get("LBL_GTM_PREFIX_OTP") + eventString,
    JSON.stringify(jsonResponse)
  );
}

//@ts-ignore (2nd method)

function regGtagOtp(e, i) {
  console.log("Env: " + getEnv() + ", GTM--->regGtagOtp called for " + e);
  //@ts-ignore
  gtag_event(
    CONST_LABELS.get("LBL_GTM_PREFIX_OTP") + e,
    i,
      // CONST_CONF.get("gTagUA")
      process.env.REACT_APP_GTAGUA
  );
  //gtag_event(CONST_LABELS.get("LBL_GTM_PREFIX_OTP")+"-GTM-"+e,i,CONST_CONF.get("gTagId"));
  //@ts-ignore
  gtagGA4("event", CONST_LABELS.get("LBL_GTM_PREFIX_OTP") + e, i);

  //@ts-ignore
  gtagGTM("event", CONST_LABELS.get("LBL_GTM_PREFIX_OTP") + e, i);
}

//@ts-ignore
function gtag_event(e, i, n) {
  //@ts-ignore
  gtag("event", e, {
    items: [
      {
        send_to: n,
        items: i,
      },
    ],
  });
}

function getEnv() {
  return CONST_CONF.get("IS_TEST_ENV") == "0" ? "PROD" : "DEV";
}

function getPinLength(productId: string) {
  var pinLength = Number(CONST_LABELS.get("PIN_LENGTH"));
  if (productId === "41") {
    pinLength = 5;
  }
  return pinLength;
}
function getProductId(phoneNumber: string, countrycode: Number) {
  // Logic for determining pin length NOT NEEDED HERE, Zain requires a length of 5, Batelco only 4

  //322, 383, 384, 388, 39	Mobile	Batelco, 36, 377	Mobile	Zain
  var carrier = "41";
  if (
    phoneNumber.startsWith(countrycode + "322") ||
    phoneNumber.startsWith(countrycode + "383") ||
    phoneNumber.startsWith(countrycode + "384") ||
    phoneNumber.startsWith(countrycode + "388") ||
    phoneNumber.startsWith(countrycode + "39") ||
    phoneNumber.startsWith(countrycode + "33")
  ) {
    carrier = "42";
  }
  return carrier;
}

export {
  resourceKey,
  regex,
  CONST_LABELS,
  CONST_CONF,
  CONST_TERMS,
  CONST_LABELS_LNG,
  getProductId,
  getPinLength,
  regGtagOtp,
  regGtagOtpValidate,
  regConversion,
  regGtagOtpWithJson,
};
